// BidHistory.js
import React from "react";
import "./BidHistory.css";
import { useSelector,useDispatch } from "react-redux";
import { get_all_depends } from "../features/userSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import { nodataStyle } from "../constant/constant";
import { useT } from "../i18n";

const generateUniqueId=()=>{
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let uniqueId = '';

  for (let i = 0; i < 26; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    uniqueId += chars.charAt(randomIndex);
  }

  return uniqueId;
}

export const getTyPoint=(data)=>{
  var Art_num='';
  switch (data.game_type) {
    case 'Single Digit':
      Art_num=(data.session==='Close')?data.close_digit:data.open_digit;
      break;
    case 'Jodi Digit':
      Art_num=`${data.open_digit}${data.close_digit}`;
      break;
    case 'Single Pana':
      Art_num=(data.session==='Close')?data.close_pana:data.open_pana;
      break;
    case 'Double Pana':
      Art_num=(data.session==='Close')?data.close_pana:data.open_pana;
      break;
    case 'Triple Pana':
      Art_num=(data.session==='Close')?data.close_pana:data.open_pana;
      break;
    case 'Half Sangam':
      if(data.close_pana==='NA'){
        Art_num=`${data.open_pana}-${data.close_digit}`;
      }else{
        Art_num=`${data.close_pana}-${data.open_digit}`;
      }
      break;
    case 'Full Sangam':
      Art_num=`${data.open_pana}-${data.close_pana}`;
      break;
    default:
      break;
  }
  return Art_num;
}

// Fetches the logged-in user's bid history into the store
export const useBidHistory = () => {
  const { isUserLogedIn,Info,user_bids_history } = useSelector((state) => state.users);
  const dispatch=useDispatch();
  React.useEffect(()=>{
    if(isUserLogedIn){
      let data = new FormData();
      data.append('phone_number',Info?.phone_number);
      dispatch(get_all_depends({request_type:'get_bid_history',data:data}));
    }
  },[isUserLogedIn,Info?.phone_number,dispatch])
  return Array.isArray(user_bids_history) ? user_bids_history : [];
}

export const BidCards = ({ bids, emptyState, padding = '4%' }) => {
  const { t } = useT();
  return (
  <div className="all_bids" style={{padding}}>
    {bids.map((data_camp, index) => (
      <div className="game-card" key={index}>
        <div className="upper_fund_card">
          <div className="game_card_left" style={{textAlign:'left'}}>
            <div className="game-name marginAcc colorRed" >{data_camp.date}</div>
            <div className="game-name marginAcc" >
              <span style={{fontWeight:'600'}}>{data_camp.game_name}</span><br/>
              <span>{t(data_camp.game_type)}, {`${t(data_camp.session)}:${getTyPoint(data_camp)}`}</span>
            </div>
            <div className="game-name marginAcc" style={{fontSize:'small'}} ><span style={{fontWeight:'600'}}> {t('Transaction ID')}:</span><br/><span>{generateUniqueId()}</span></div>
            <div className="game-name marginAcc colorRed" ><FontAwesomeIcon fontWeight={'300'} icon={faIndianRupeeSign} size='1x'/>{data_camp.points_action}</div>
          </div>
          <div className="game_card_right">
            <div className="game-name" style={{whiteSpace:'nowrap'}}><span style={{color:'gray'}}>{t('Placed')}</span></div>
          </div>
        </div>
      </div>
    ))}

    {(bids.length===0) && (emptyState || nodataStyle(t('No bid history found.')))}
    <style jsx>
      {
        `.game-card {
            background-color: #fff;
            padding: 15px;
            margin-bottom: 15px;
            border-radius: 9px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
            display: flex;
            flex-direction: column;
        }
         .upper_fund_card{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
         }
        .colorRed{
        color:#007bff;
        }
        .marginAcc{
        margin-top:6px;
        }
      `
      }
    </style>
  </div>
  );
};

const BidHistory = () => {
  const bids = useBidHistory();
  return <BidCards bids={bids} />;
};

export default BidHistory;
